'use client';

import { useRef } from 'react';
import { Box } from '@mui/material';

import { SearchInput, TabSwitcher } from '@/components';
import { useT } from '@/hooks';
import { ProfilePositionsSortMenu } from './ProfilePositionsSortMenu';

interface ProfilePositionsFiltersProps {
  tab: string;
  onTabChange: (tab: string) => void;
  search: string;
  onSearchChange: (search: string) => void;
  sortBy: string;
  onSortChange: (key: string) => void;
  effectiveSortBy: string;
}

// filterOptions will be generated dynamically using translations

export const ProfilePositionsFilters = ({
  tab,
  onTabChange,
  search,
  onSearchChange,
  sortBy,
  onSortChange,
  effectiveSortBy,
}: ProfilePositionsFiltersProps) => {
  const searchRef = useRef<HTMLDivElement>(null);
  const { t } = useT();

  const filterOptions = [
    { label: t('leaderboardPortfolio.active'), value: 'Active' },
    { label: t('leaderboardPortfolio.closed'), value: 'Closed' },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ flex: 1 }}>
          <TabSwitcher
            options={filterOptions}
            activeTab={tab}
            onTabChange={onTabChange}
            variant="subtle-pills"
            containerSx={{
              width: '100%',
              mb: 0,
              display: 'flex',
              '& button': { height: 46, flex: 1 },
            }}
          />
        </Box>
        <Box sx={{ flexShrink: 0 }}>
          <ProfilePositionsSortMenu
            tab={tab}
            sortBy={sortBy}
            onSortChange={onSortChange}
            effectiveSortBy={effectiveSortBy}
          />
        </Box>
      </Box>

      <SearchInput
        placeholder={t('leaderboardPortfolio.searchPositions')}
        value={search}
        onChange={onSearchChange}
        inputRef={searchRef}
        height={46}
      />
    </Box>
  );
};
